import React from 'react';
export function ProductSpecificationsSection() {
  const specs = [{
    label: 'Power:',
    value: 'Electric automatic peeler'
  }, {
    label: 'Blade:',
    value: 'Stainless steel'
  }, {
    label: 'Use:',
    value: 'Apples, pears, potatoes & more'
  }, {
    label: 'Size:',
    value: 'Compact, lightweight design'
  }];
  return <div className="w-full max-w-[1400px] mt-16 px-4" data-id="element-316">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 bg-white rounded-3xl overflow-hidden shadow-lg" data-id="element-317">
        {/* Left Side - Specifications */}
        <div className="bg-gray-200 p-8 md:p-12 flex flex-col justify-center" data-id="element-318">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-8" data-id="element-319">
            Product Specifications
          </h2>

          <ul className="space-y-6" data-id="element-320">
            {specs.map((spec, index) => <li key={index} className="flex flex-col" data-id="element-321">
                <span className="text-lg text-black mb-1" data-id="element-322">● {spec.label}</span>
                <span className="text-lg font-bold text-black ml-4" data-id="element-323">
                  {spec.value}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Right Side - Product Image with Dimensions */}
        <div className="bg-white p-8 md:p-12 flex items-center justify-center" data-id="element-324">
          <img src="https://cdn.magicpatterns.com/uploads/2pYL4krRfFzuzRY2Jmvbw2/image.png" alt="Product dimensions" className="w-full h-auto max-w-md" data-id="element-325" />
        </div>
      </div>
    </div>;
}